export default __webpack_public_path__ + "static/media/marauders-map-v4-02-01.d5678dc2.jpg";